import SDKConfigurationModel from "../../../Configurator/Models/SDKConfiguraitonModel";
import CustomGameHttps from "../../../Https/CustomGameHttps";
import ProfileModel from "../../Profile/Models/ProfileModel";
import Profile from "../../Profile/Profile";
import StandingGamesFilters from "../Models/Filters/StandingGamesFilters";
import StandingGameRankingsFilters from "../Models/Filters/StandingGameRankingsFilters";
import StandingGameValidator from "../Validator/StandingGameValidator";

export default class StandingGameFacade {
  private https: CustomGameHttps = null;
  private profile: Profile = null;
  private validator: StandingGameValidator = null;

  constructor(config: SDKConfigurationModel) {
    this.https = new CustomGameHttps(config);
    this.profile = new Profile(config);
    this.validator = new StandingGameValidator(config.errorHandlingMode);
  }

  public getGames = async (
    filters: StandingGamesFilters,
    disableCache: boolean
  ) => {
    if (filters) {
      filters = new StandingGamesFilters(filters);
    }

    return await this.https.getStandingsGames(filters, disableCache);
  };

  public getGameById = async (gameId: string, disableCache: boolean) => {
    return await this.https.getStandingGameById(gameId, disableCache);
  };

  public makePrediction = async (gameId: string, prediction: string[]) => {
    this.validator.validatePrediction(prediction);

    return await this.https.makeStandingGamePrediction(gameId, prediction);
  };

  public updatePrediction = async (
    gameId: string,
    predictionId: string,
    prediction: string[]
  ) => {
    this.validator.validatePrediction(prediction);

    return await this.https.updateStandingGamePrediction(
      gameId,
      predictionId,
      prediction
    );
  };

  public getGamePredictionForUser = async (
    gameId: string,
    profileId: string,
    disableCache: boolean
  ) => {
    const data = await this.https.getStandingGamePredictionsForUser(
      gameId,
      profileId,
      disableCache
    );

    let profileModel = null;

    try {
      profileModel = await this.profile.getById(profileId).getInfo();
    } catch (error) {
      console.error(error);
    }

    data.data.forEach((prediction) => {
      prediction.profileModel = profileModel;
    });

    return data;
  };

  public getRankings = async (
    gameId: string,
    filters: StandingGameRankingsFilters,
    disableCache: boolean
  ) => {
    if (filters) {
      filters = new StandingGameRankingsFilters(filters);
    }

    const response = await this.https.getStandingGameRankings(
      gameId,
      filters,
      disableCache
    );
    const profileIds = response.data.map((d) => d.profileId);
    let profiles: ProfileModel[] = [];

    if (profileIds.length > 0) {
      profiles = await this.profile.getByIds(profileIds);
      response.data = response.data.map((d) => {
        d.profileModel = profiles.find((p) => p.id === d.profileId) || null;

        return d;
      });
    }

    return response;
  };
}
